<template>
  <div class="good-review">
    <div class="xs-header-left">
      {{ title }}
    </div>
    <div class="content">
      <div v-swiper:mySwiperheart="swiperOptions" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(arr, i) in list.slice(0, 5)"
            :key="i"
            class="swiper-slide content-item"
            @click="toPage(i)"
            v-stat="'用户心声-点击评价'"
          >
            <div class="first" v-if="infoType == 'userInfo'">
              <img
                :src="arr.avatar && !+arr.is_guest ? arr.avatar : nickImg"
                alt=""
                class="first-img"
              />
              <span class="first-name">{{
                arr.nickname && !+arr.is_guest ? arr.nickname : '匿名用户'
              }}</span>
            </div>
            <div class="first" v-else>
              <img :src="arr.teacher_info.avatar" alt="" class="first-img" />
              <span class="first-name">{{ arr.teacher_info.name }}</span>
            </div>

            <div class="content-text">{{ arr.content }}</div>
          </div>
        </div>
        <!-- <div class="content-shadow"></div> -->
      </div>
    </div>
    <div
      class="xs-header-right"
      @click="toPage('more')"
      v-if="moreBtn"
      v-stat="'用户心声-查看更多'"
    >
      <icon name="qingsu-home-right-arrow" class="xs-header-right-icon" />
    </div>
  </div>
</template>
<script>
// import { chunk } from 'utils/arrayUtil'
import { formatDate } from 'utils/index'

export default {
  props: {
    list: {
      type: [Array, Object],
      default: () => []
    },
    title: {
      // 标题
      type: String,
      default: '用户心声'
    },
    moreBtn: {
      // 查看更多按钮是否显示
      type: Boolean,
      default: true
    },
    infoType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      reviewList: [],
      nickImg:
        'https://ossimg.xinli001.com/20180424/9da8e88ceedc5eb1a901c6920fe17794.png',
      activeSwiper: {
        index: 0,
        swipeDirection: ''
      }
    }
  },
  computed: {
    swiperOptions() {
      return {
        direction: 'vertical',
        loop: true,
        spaceBetween: 0,
        speed: 600,
        allowTouchMove: false,
        autoplay:
          this.list.length > 1
            ? {
                disableOnInteraction: false,
                delay: 6000 // 6秒切换一次
              }
            : false
      }
    }
  },
  methods: {
    formatDate,
    // ==================================== 一、逻辑类 ====================================

    // ==================================== 二、数据请求类 ================================
    // 评论数据
    // async getList() {
    //   const res = await thankrate({ page: 1 })
    //   if (res && res.code == 0) {
    //     this.reviewList = res.data.thank_rate
    //   }
    // },

    // ==================================== 三、跳转类 ====================================
    // 页面跳转
    toPage(item) {
      // const { cid } = this.$route.query || ''
      this.routerPush({
        path: '/qingsu/heart',
        query: {
          cid: this.$route.query.cid || '',
          index: item == 'more' ? -1 : item
        }
      })
      this.$emit('clickItem', item)
    },

    // ==================================== 四、小工具类 ==================================
    // 判断日期是否为当年
    currentYear(data) {
      if (!data) return
      let myDate = new Date().getFullYear()
      let years = formatDate(data, 'Y')
      return years == myDate
    }
  }
}
</script>
<style lang="scss" scoped>
.good-review {
  margin-bottom: 63px;
  margin-top: 60px;
  padding: 10px 30px;
  width: 690px;
  height: 160px;
  box-sizing: border-box;
  background-color: #fff;

  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  box-shadow: 0 0.10667rem 0.53333rem 0 #ececec;
  border-radius: 0.4rem;

  background-image: url('../../../../static/img/xinsheng-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .content {
    height: 160px;
    flex: 1;
    ::v-deep .swiper-container {
      position: relative;
      height: 100%;
      // padding: 20px 0 40px;
    }
    &-item {
      margin: 0 auto;
      padding: 10px 10px 0;
      overflow: hidden;
      box-sizing: border-box;

      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .first {
        display: flex;
        align-items: center;
        &-img {
          width: 38px;
          height: 38px;
          border-radius: 50%;
        }
        &-name {
          font-size: 26px;
          margin-left: 20px;
          color: #6c798c;
        }
      }
      .content-text {
        margin: 12px 0 0;
        font-size: 30px;
        // line-height: 48px;
        color: #21252d;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        word-break: break-all;
      }
      .second {
        display: flex;
        width: 550px;
        align-items: center;
        padding: 16px 20px;
        background: #f5f5f7;
        border-radius: 10px;
        box-sizing: border-box;
        &-img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          object-fit: cover;
        }
        &-right {
          margin-left: 20px;
          // width: 536px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-name {
          font-size: 32px;
          margin-right: 16px;
          font-weight: bold;
          color: #21252d;
        }
        &-tags {
          font-size: 26px;
          color: #6c798c;
        }
      }
    }
  }

  .xs-header-left {
    font-size: 32px;
    // width: 2em;
    width: 68px;
    color: #ff745b;
    font-weight: bold;
    padding-right: 15px;
    margin-right: 15px;
    border-right: 1px solid #eaeaea;
  }

  .xs-header-right {
    font-size: 1.4em;
    padding-left: 6px;

    .xs-header-right-icon {
      color: rgb(162, 160, 156);
    }
  }
}
</style>
